// Redux reducer for i18n language state

export const SET_LANGUAGE = 'I18N_SET_LANGUAGE'

const INITIAL_STATE = {
  language: null // Will be initialized from i18next
}

export default function i18nReducer (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload
      }
    default:
      return state
  }
}

// Action creators
export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: language
})
